import { ARIA_TENANT_TOKENS } from 'mini-app-analytics/lib/utils/constants';
import { determineModule } from './determineModule';
import { getServerAppNameForModule } from 'mini-bootstrap-config/lib/getServerAppNameForModule';
import { initiatePerformanceObserverForCriticalResource } from 'mini-common-bootstrap/lib/initiatePerformanceObserverForCriticalResource';
import { lazyFrameworkBootstrap } from 'mini-app-module';
import { miniStart } from 'mini-start';
import { moduleToConfigMap } from 'mini-bootstrap-config';
import { runAfterRequests } from 'mini-bootstrap-config/lib/runAfterRequests';
import 'mini-global-styles';
// order matters. Make sure we load mini-start first as it has the polyfills we need for owa-bundling to work
import type { HandleBootErrorFunction } from 'owa-shared-start/lib/interfaces/StartConfig';
import type StartConfig from 'mini-start/lib/types/StartConfig';
import type { SessionData } from 'owa-service/lib/types/SessionData';

interface AppStartParams {
    handleBootError?: HandleBootErrorFunction;
    overrideBootPromises?: (authToken?: string) => Promise<SessionData>;
    onAuthFailure?: (claimsChallenge: string | null) => void;
    onFatalBootError?: () => void;
    onLoaderRemoved?: () => void;
    runBeforeStart?: (config: StartConfig) => Promise<void>;
}

export function mailStart(params: AppStartParams = {}) {
    const {
        runBeforeStart,
        onFatalBootError,
        onLoaderRemoved,
        overrideBootPromises,
        handleBootError,
    } = params;
    const module = determineModule();
    const startLazyConfig = moduleToConfigMap[module];
    const serverAppName = getServerAppNameForModule(module);

    // Register perf observer to start tracking resource load times
    initiatePerformanceObserverForCriticalResource();

    const appStartConfig: StartConfig = {
        app: serverAppName,
        runBeforeStart,
        startupAriaToken: ARIA_TENANT_TOKENS[0],
        loadBpos: true,
        onFatalBootError: onFatalBootError,
        bootstrap: lazyFrameworkBootstrap,
        options: startLazyConfig.options,
        overrideBootPromises,
        runAfterRequests: () => {
            runAfterRequests(module);
        },
        handleBootError,
        onLoaderRemoved,
    };

    miniStart(appStartConfig);
}
